import { hex_sha1 } from './sha1.js'
import cookie from './cookie';
let config = {}
// config.cl = 'web_baofeng';// minipro
config.cl = 'newweb_baofeng';// minipro
if (location.href.indexOf('player') != -1) {
  config.cl = 'newweb_baofeng'
}
//波塞冬版本号
config.ves = 1;
config.uc = 111;
config.uid = function () {
  let _uid = 0;
  try {
    _uid = JSON.parse(cookie.get('user')).userid;
  } catch (e) {
    _uid = 0;
  }
  return _uid;
}();


//客户端版本(会被其它页面专入的地址栏参数覆盖)
config.client_version = function () {
  let key = '_ver';
  let ver = cookie.get(key);
  let qver = T.url.getQueryValue('ver');
  if (qver && qver != ver) {
    ver = qver;
  }
  cookie.set(key, ver);
  return ver;
}();
config.protocol = window.location.protocol == 'https:' ? 'https:' : 'http:';
/** uuid 唯一标记，一个页面只有一个*/
config.uuid = function () {
  var calculate = function (src) {
    return hex_sha1(src);
  }
  var counter = 0;
  var create = function () {
    var dt = new Date();
    var id1 = dt.getTime();
    var id2 = Math.random() * Number.MAX_VALUE;
    //var id3 = Capabilities.serverString;
    var id3 = navigator.userAgent;
    var rawID = calculate(id1 + id3 + id2 + counter++).toUpperCase();
    var finalString = rawID.substring(0, 8) + "-" + rawID.substring(8, 12) + "-" + rawID.substring(12, 16) + "-" + rawID.substring(16, 20) + "-" + rawID.substring(20, 32);
    return finalString;
  }
  let that = self || this;
  if (!that._guid) {
    that._guid = create();
  }
  return that._guid;
}();

config.fudid = function () {
  var _guid = T.url.getQueryValue('uuid');
  if (_guid) {
    _guid = _guid.replace(/-/g, '').toLocaleLowerCase();
    cookie.set('bf_fudid', _guid);
    return _guid
  }
  if (cookie.get('bf_fudid')) {
    _guid = cookie.get('bf_fudid');
    return _guid
  }
  var calculate = function (src) {
    return hex_sha1(src);
  }
  var counter = 0;
  var create = function () {
    var dt = new Date();
    var id1 = dt.getTime();
    var id2 = Math.random() * Number.MAX_VALUE;
    //var id3 = Capabilities.serverString;
    var id3 = navigator.userAgent;
    var rawID = calculate(id1 + id3 + id2 + counter++).toUpperCase();
    var finalString = rawID.substring(0, 8) + rawID.substring(8, 12) + rawID.substring(12, 16) + rawID.substring(16, 20) + rawID.substring(20, 32);
    return finalString.toLocaleLowerCase();
  }
  _guid = create();

  return _guid;
}();

config.getSystemInfo = function () {
  if (!this._systeminfo) {
    this._systeminfo = function () {
      var sUserAgent = navigator.userAgent;
      var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
      var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
      if (isMac) return "Mac";
      var isUnix = (navigator.platform == "X11") && !isWin && !isMac;
      if (isUnix) return "Unix";
      var isLinux = (String(navigator.platform).indexOf("Linux") > -1);
      if (isLinux) return "Linux";
      if (isWin) {
        if (sUserAgent.indexOf("Windows NT 5.") > -1 || sUserAgent.indexOf("Windows XP") > -1) {
          return "XP";
        } else if (sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1) {
          return "Vista";
        } else if (sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1) {
          return "win7";
        } else if (sUserAgent.indexOf("Windows NT 6.3") > -1 || sUserAgent.indexOf("Windows 8") > -1) {
          return "win8";
        } else if (sUserAgent.indexOf("Windows NT 10.") > -1 || sUserAgent.indexOf("Windows 10") > -1) {
          return "win10";
        }
      }
    }();
  }
  return this._systeminfo
}

config.domain = {};
config.domain.statHost = config.protocol + '//stat.funshion.com'
config.development = (typeof env != 'undefined' && env == 'development') ? true : false;

//上报动态参数，会在exposure上报，或者视频播关互时动态变化
config.report_dynamic = config.report_dynamic || { autoplay: 0 };


//flash播放器模块
config.flashvod = "http://static.funshion.com/market/p2p/openplatform/master/2020-5-21/BF_FunVodPlayer_1005.swf";
//flash广告模块
config.flashads = "http://static.funshion.com/market/p2p/preroll/bf_webpreroll_20200515_1419.swf";

config.ERR_INFO = {
  "400": '手机号码无效',
  "401": '验证码错误',
  "402": '手机格式错误',
  "403": '手机发送验证码超过限制次数',
  "500": '程序错误',
  "1000": '未知原因',
  "1038": '用户输入的图形验证码错误',
  "1431": '手机号码发送短信太频繁',
}



export default config;



// WEBPACK FOOTER //
// ./src/assets/js/config.js